import { type TagWithScope } from '#shared/lib/integrations';

export const getIntegrationMappingTagsKey = (tags: TagWithScope[]): string =>
    tags
        .map((tag) => `${tag.scopeArea}:${String(tag.key)}`)
        .sort()
        .join('|');
